export const AUTH_ERRORS = [
  'Controller:Auth',
  'Controller:Client::Could not find client',
];
